import { render, staticRenderFns } from "./HistoryAll.vue?vue&type=template&id=9977c076&"
import script from "./HistoryAll.vue?vue&type=script&lang=js&"
export * from "./HistoryAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports